import React, { useState } from 'react';

interface HealthDotProps {
  status: 'green' | 'amber' | 'red' | 'gray';
  reason?: string;
  size?: 'sm' | 'md';
  pulse?: boolean;
}

const HealthDot: React.FC<HealthDotProps> = ({ status, reason, size = 'sm', pulse = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const colorMap = {
    green: 'bg-green-500',
    amber: 'bg-amber-500',
    red: 'bg-red-500',
    gray: 'bg-gray-500',
  };

  const sizeMap = { sm: 'w-2 h-2', md: 'w-3 h-3' };

  return (
    <span className="relative inline-flex items-center">
      <span
        className={`rounded-full ${colorMap[status]} ${sizeMap[size]} ${pulse ? 'animate-pulse' : ''} transition-shadow duration-200`}
        style={{
          boxShadow: showTooltip
            ? `0 0 8px ${status === 'green' ? '#22c55e' : status === 'amber' ? '#f59e0b' : status === 'red' ? '#ef4444' : '#6b7280'}50`
            : 'none',
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      />
      {showTooltip && reason && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 text-xs bg-gray-900 text-white rounded whitespace-nowrap z-50">
          {reason}
        </span>
      )}
    </span>
  );
};

export default HealthDot;
